export default "__VITE_ASSET__CXiYyrrC__"